import {
  SaveCompletionFeedbackMutationVariables,
  useResetCompletionFeedbackMutation,
  useSaveCompletionFeedbackMutation
} from "../../api/generated"
import { updateCacheOnReview } from "../../completion/feedback/useSaveCompletionFeedbackMutation"
import { TreeNode } from "./tree/path-tree"

export type ReviewItemOptions = {
  item: TreeNode<"completion">
} & Omit<Required<SaveCompletionFeedbackMutationVariables>, "id" | "pathId">

const useReviewMutations = () => {
  const [saveCompletionFeedback] = useSaveCompletionFeedbackMutation()
  const [resetCompletionFeedback] = useResetCompletionFeedbackMutation()

  const reviewItem = async ({
    item,
    userpointsExplanation,
    userpointsEarned,
    notify = true
  }: ReviewItemOptions) => {
    const variables = {
      id: item.data.id,
      pathId: item.data.path_id,
      userpointsEarned,
      userpointsExplanation,
      notify
    }
    let result = await saveCompletionFeedback({
      variables,
      update: updateCacheOnReview(
        item.data.completion.user?.id!,
        !!item.data.completion?.needs_grading,
        (result) => result.data.saveCompletionFeedback.needs_grading
      ),
      refetchQueries: ["InboxGroupConnections"]
    })
    return result
  }

  const resetReview = async (item: TreeNode<"completion">) => {
    const variables = {
      id: item.data.id,
      pathId: item.data.path_id
    }
    let result = await resetCompletionFeedback({
      variables,
      update: updateCacheOnReview(
        item.data.completion.user?.id!,
        !!item.data.completion?.needs_grading,
        (result) => result.data.resetCompletionFeedback.needs_grading
      ),
      refetchQueries: ["InboxGroupConnections"]
    })
    return result
  }

  return { reviewItem, resetReview }
}

export default useReviewMutations
